import api from './api';
import { User } from '../types';

// Get current user info from the /me endpoint (now allows unverified email)
export const getCurrentUser = async (): Promise<User | null> => {
  try {
    const response = await api.get('/me');
    const userData = response.data;
    
    // Fetch user's clubs
    let clubs = [];
    try {
      const clubsResponse = await api.get('/me/clubs', {
        // Suppress error logging for 404 responses
        validateStatus: (status) => status < 500
      });
      
      if (clubsResponse.status === 404) {
        // User has no clubs, which is normal
        clubs = [];
      } else {
        clubs = Array.isArray(clubsResponse.data) ? clubsResponse.data : [clubsResponse.data];
      }
    } catch (error: any) {
      // Only log unexpected errors
      console.error('Failed to fetch user clubs:', error);
      clubs = [];
    }
    
    return {
      id: userData.id,
      username: userData.name || '',
      email: userData.email || '',
      nickname: userData.nickname,
      user_type: userData.user_type,
      is_pilot: userData.is_pilot ?? false,
      email_verified: userData.email_verified ?? false,
      is_active: userData.email_verified ?? true,
      is_platform_admin: userData.is_platform_admin ?? false,
      created_at: userData.created_at || '',
      updated_at: userData.updated_at || '',
      clubs: clubs,
    };
  } catch (error) {
    console.error('Unable to fetch current user details:', error);
    return null;
  }
};